export const emrRouteDef = [
    {
        path: ':key/patient_emr',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format',
            queryParams: {
                "banner": {
                    "selector": "emr-patient-layout",
                    "component": "hidden",
                    "datasource": {
                        "application": "patient-registration",
                        "resource": "patient",
                        "query_id": "GET_BY_ID"
                    },
                    "jsonName": "patient_banner_op_emr"
                },
            }
        }
    },
    {
        path: ':resource/EDIT_GRID',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            action: 'EDITGRID',
            "resource": "work_injury_report"
        }
    },
    {
        path: 'immunization_admission_vaccine_details',
        component: 'ImmunizationChartComponent',
        data: {
            selector: 'kx-immunization-chart',
            resource: 'immunization_admission_vaccine_details',
            action:"LIST"
        }, 
    },
    {
        path: 'ai-agent-dashboards',
        component: 'AiAgentDashboardsComponent',
        data: {
            selector: 'app-ai-agent-dashboards',
        }, 
    },
    {
        path: ':key/patient_admission',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format_admission',
            queryParams: {
                "banner": {
                    "selector": "emr-patient-layout",
                    "component": "hidden",
                    "datasource": {
                        "application": "adt",
                        "resource": "encounter",
                        "query_id": "GET_PATIENT_BY_PATIENT_ID",
                    },
                    "jsonName": "patient_banner_ip_admission"
                },
            }
        }
    },
    {
        path: 'viewUpload_patient_document',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: 'viewUpload_patient_document',
            action: 'IMAGE_VIEWER',
        }
    },
    {
        path: ':resource/billingDesign',
        component: 'IpBillingMainComponent',
        data: {
            selector: 'app-ip-billing-main',
            resource: 'billing_format_ip'
        },

    },
    {
        path: ':resource/billingDesignviewdetails',
        component: 'IpBillingMainComponent',
        data: {
            selector: 'app-ip-billing-main',
            resource: 'view_detail_format_ip'
        }
    },
    {
        path: 'patient_document',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: 'patient_document',
            action: 'IMAGE_VIEWER',
        }
    },
    {
        path: 'fit_unfit_package_certificate',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'fit_unfit_package_certificate',
            action: 'ADD',
        }
    },
    {
        path: ':id/view_fit_unfit_package_certificate',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'fit_unfit_package_certificate',
            action: 'MODIFY',
        }
    },
    {
        path: 'clm_package_summary',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'clm_package_summary',
            action: 'ADD',
        }
    },
    {
        path: ':id/view_clm_package_summary',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'clm_package_summary',
            action: 'MODIFY',
        }
    },
    {
        path: 'death_certificate_template',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: 'death_certificate',
            action: 'ADD',
        }
    },
    {
        path: 'emr_patient_assessment/self',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: 'emr_patient_assessment',
            action: 'ADD'
        }
    },
    {
        path: 'clearance_status_emr',
        component: 'TrackStatusComponent',
        data: {
            selector: 'kx-track-status',
            resource: 'encounter_dischargeClearance'
        }
    },
    {
        path: ':resource/patient_clearence',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
        }
    },
    {
        path: 'vitals-view',
        component: 'VitalsViewComponent',
        data: {
            selector: 'app-vitals-view'
        }
    },
    {
        path: 'emr-vitals',
        component: 'EmrVitalsComponent',
        data: {
            selector: 'app-emr-vitals'
        }
    },
    {
        path: 'vitals',
        component: 'AddVitalsComponent',
        data: {
            selector: 'app-add-vitals'
        }
    },
    {
        path: ':resource/:orderId/:resource/add',
        component: 'DynamicGridWithControlsComponent',
        data: {
            selector: 'kx-editable-grid'
        }
    },
    {
        path: ':resource/:id/copyfeature',
        component: 'PopupEditableGridWithBannerComponent',
        data: {
            selector: 'app-popup-editable-grid-with-banner',
            resource: 'casesheet_master'
        }
    },
    {
        path: ':resource/:id/copyfeature_advice',
        component: 'PopupEditableGridWithBannerComponent',
        data: {
            selector: 'app-popup-editable-grid-with-banner',
            resource: 'advice_task_master'
        }
    },
    {
        path: ':foreign_id/intervention_details/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'intervention_details',
            action: 'FORM_GRID',
            foreign_id: 'painassessmentId'
        }
    },
        {
        path: ':id/submitted_bill_queries/billingDesign',
        component: 'SharedUEngineComponent',
        data: {
            selector: 'app-shared-u-engine',
            resource: 'submitted_bill_queries',
            action: 'VIEW',
            screen:'query'
        }
    },
    {
        path: ':foreign_id/maintenance_details/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'maintenance_details',
            action: 'FORM_GRID',
            foreign_id: 'insertionMonitoringId'
        }
    },
    {
        path: ':action/:key/emrcounsellingView',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'counselling_emr_format',
            viewOnly: 'view'
        }
    },
    {
        path: ':id/submitted_bill_queries/billingDesignanswer',
        component: 'SharedUEngineComponent',
        data: {
            selector: 'app-shared-u-engine',
            resource: 'submitted_bill_queries',
            action: 'VIEW',
            screen:'answer'
        }
    },
    {
        path: ':resource/design',
        component: 'InsuranceBillingComponent',
        data: {
            selector: 'app-insurance-billing',
            resource: 'billing_upload'
        }
    },
    {
        path: ':foreign_id/removal_details/view',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'removal_details',
            action: 'ADD',
            foreign_id: 'id'
        }
    },
    // this path is written for medication order for navigating same component in allergy tab
    {
        path: ':action/:key/editEMR',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format'
        }
    },
    {
        path: ':action/:key/emrDesign',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format'
        }
    },
    {
        path: ':action/:key/emrDiagnosticDesign',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_diagnostic_format'
        }
    },
    {
        path: ':action/:key/editEMR/medicationOrdersdirect',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format_opmedication'
        }
    },
    {
        path: ':action/:key/editEMR/clinicalOrdersdirect',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format_opmedication'
        }
    },
    {
        path: ':action/:key/editEMR/emrMedication',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format_medication'
        }
    },
    {
        path: ':action/:key/editEMR/itemConsumption',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format_item_consumption'
        }
    },
    {
        path: ':action/:key/editEMR/emrClinical',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format_clinical'
        }
    },
    {
        path: ':foreign_id/intervention_details/list',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'insertion_details_view',
            action: 'LIST',
            foreign_id: 'painassessmentId'
        }
    },
    {
        path: ':action/:key/emrView',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format',
            viewOnly: 'view'
        }
    },
    {
        path: ':id/:resource/appointmentTrack',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'appointment_track_details'
        }
    },
    {
        path: ':id/:resource/collectsample',
        component: 'DiagnosticEditableGridComponent',
        data: {
            selector: 'app-diagnostic-editable-grid'
        }
    },
    {
        path: ':id/:resource/order',
        component: 'EditableGridWithBannerComponent',
        data: {
            selector: 'kx-editable-grid-with-banner'
        }
    },
    {
        path: 'ot_waitlist_diary/list',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            action: 'LIST',
            resource: 'ot_waitlist_diary'
        }
    },
    {
        path: ':id/:resource/bloodReceiving',
        component: 'DiagnosticEditableGridComponent',
        data: {
            selector: 'app-diagnostic-editable-grid'
        }
    },
    {
        path: ':id/:resource/bloodCancel',
        component: 'DiagnosticEditableGridComponent',
        data: {
            selector: 'app-diagnostic-editable-grid'
        }
    },
    {
        path: 'opthal',
        component: 'OpthalmicExaminationComponent',
        data: {
            selector: 'kx-opthalmic-examination'
        }
    },
    {
        path: 'google-fit',
        component: 'GooglefitComponent',
        data: {
            selector: 'app-google-fit'
        }
    },
    {
        path: 'opthal-flow',
        component: 'V1PrescriptionComponent',
        data: {
            selector: 'app-v1-prescription'
        }
    },
    {
        path: 'smart-fill',
        component: 'SmartFillComponent',
        data: {
            selector: 'app-smart-fill'
        }
    },
    {
        path: "tui",
        component: 'ImageEditorComponent',
        data: {
            selector : "app-image-editor"
        }
    },
    {
        path:'itemConsumption',
        component:'ItemConsumptionComponent',
        data : {
            selector: 'kx-item-consumption',
            resource: 'item_consumption_walkin'
        }
    },
    {
        path: 'referral_history_view',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            resource: 'referral_history_view',
            action: 'LIST',
        }
    },
    {
        path: 'cryoRequest',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'cryopreservation_virtification',
            action: 'ADD',
        }
    },
    {
        path: 'emr_worklist',
        component: "EmrWorklistComponent",
        data: {
            selector: 'app-emr-worklist'
        }
    },
    {
        "path": "patient-protocol",
        "component": "ChemotherapyProtocolComponent",
        "data": {
            "selector": "app-chemotherapy-protocol"
        }
    },
    {
        path: 'mdt_template_modify',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: 'mdt_template_view_modify_resource',
            action: 'MODIFY',
        }
    },
    {
        path: 'mdt_template_view',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: 'mdt_template_view_modify_resource',
            action: 'VIEW',
        }
    }
]